import { nullToUndefined_default } from "./nullToUndefined-DPLuoDzT.mjs";

//#region src/path.ts
/**
* Safely get a nested path from an object.
* You might just be able to use optional chaining for this.
*
* * Returns a value or undefined.
* * Never returns null.
* * Works with null or undefined inputs.
* * TypeSafe and correctly infers output type.
* * Does not require type parameters, but can support them.
* * Can be used to get an item from an Array by index
*
* @category Objects
* @example
* ```ts twoslash
* import { path } from '@simplisafe/ewok'
*
* path([ 'one', 'two' ], { one: { two: 42 }})
* ```
*/
function path(keys, obj) {
	return arguments.length === 2 ? nullToUndefined_default(keys.reduce((acc, key) => acc ? acc[key] : void 0, obj)) : (_obj) => nullToUndefined_default(keys.reduce((acc, key) => acc ? acc[key] : void 0, _obj));
}

//#endregion
export { path };
//# sourceMappingURL=path-DJdDQTdz.mjs.map